import "./simulatorButtons.sass";

/**
 * Componente que renderiza los botones de control del simulador
 * Maneja las acciones principales: generar valores aleatorios y limpiar
 * 
 * @param {Object} props - Propiedades del componente
 * @param {Function} props.onAleatorio - Callback para generar marcadores aleatorios
 * @param {Function} props.onLimpiar - Callback para limpiar todos los marcadores
 * 
 * @returns {JSX.Element} Contenedor con los tres botones de control
 */
export default function SimulatorButtons({ onAleatorio, onLimpiar }) {
  return (
    <div className="simulador-liguilla__buttons">

      {/* Botón para resetear todos los marcadores a 0 */}
      <button onClick={onLimpiar} className="btn btn-limpiar">Reiniciar</button>

      {/* Botón para generar marcadores aleatorios (0-9 goles) */}
      <button onClick={onAleatorio} className="btn btn-aleatorio">Aleatorio</button>

    </div>
  );
}